import type { PlatformTypeName } from "@multi-chat/shared";
import { supportsOutboundNativeReply } from "./outbound-native-reply-capability.js";

export function messageCopyText(content: string | null | undefined): string | null {
  const text = content?.trim() ?? "";
  return text.length > 0 ? text : null;
}

/** Reply follows outbound native reply rules and is hidden while the thread is closed. */
export function messageToolbarActions(input: {
  platformType: PlatformTypeName;
  content: string | null | undefined;
  closed: boolean;
}): { reply: boolean; copyText: string | null } {
  return {
    reply: !input.closed && supportsOutboundNativeReply(input.platformType),
    copyText: messageCopyText(input.content),
  };
}
